<template>
  <section class="app-main" :class="is_phone ? 'height-auto' : ''">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view v-if="$route.name !== 'SystemCount'" :key="key" />
      </keep-alive>
    </transition>
    <SystemCount v-if="haveCountRoutes" v-show="$route.name === 'SystemCount'"></SystemCount>
  </section>
</template>
<script>
import SystemCount from "@/views/system-data-center/index.vue"
import { mapState } from "vuex"
import { treeToArray } from "@/utils"
export default {
  name: "AppMain",
  components: {
    SystemCount
  },
  data() {
    return {
      routerAlive: true,
      isPhone: false
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
    is_phone() {
      return this.$isPhone
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews || []
    },
    ...mapState("user", ["routes"]),
    haveCountRoutes() {
      const newRoutes = treeToArray(this.routes).filter(item => item.url.indexOf("/count") > -1)
      if (newRoutes.length > 0) {
        return true
      }
      return false
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.app-main {
  height: calc(100vh - 60px);
  width: calc(100% - 20px);
  margin-left: 10px;
  margin-top: 10px;
  position: relative;
  background: #fff;
}
.height-auto {
  //height: auto !important;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
